import { Card } from 'antd';
import React from 'react';
import { getFullName } from '../../../utils';

const PatientCareCirclecard = ({ member, showOnProfilePage, additionalActions }) => {
    const { givenName, familyName, memberTitle, telephone, email } = member
    return (
        <Card className={showOnProfilePage ? 'profile-care-circle-card card-border' : 'care-circle-card'}>
            <div className='care-cicle-card-data'>
                <div className='care-cicle-card-data-header-action'>
                    <span className='care-cicle-card-header'>{getFullName(givenName,familyName)}</span>
                    {showOnProfilePage && additionalActions(member)}
                </div>
                <span className='care-circle-card-content'>Role: <b>{memberTitle ? memberTitle : "--"}</b></span>
                <span className='care-circle-card-content'>Phone Number: <b>{telephone ? telephone : "--"}</b></span>
                <span className='care-circle-card-content'>Email: <b>{email ? email : "--"}</b></span>
            </div>
        </Card>
    );
}

export default PatientCareCirclecard;